const YOUTUBE_ID = /^[a-zA-Z0-9_-]{11}$/;

export function extractYouTubeId(value: string): string | null {
  const trimmed = value.trim();
  if (YOUTUBE_ID.test(trimmed)) return trimmed;

  try {
    const url = new URL(trimmed);
    if (url.hostname === "youtu.be") {
      const id = url.pathname.slice(1).split("/")[0];
      return YOUTUBE_ID.test(id) ? id : null;
    }
    if (url.hostname.endsWith("youtube.com")) {
      const fromQuery = url.searchParams.get("v");
      if (fromQuery && YOUTUBE_ID.test(fromQuery)) return fromQuery;
      const parts = url.pathname.split("/").filter(Boolean);
      const marker = parts.findIndex((part) => ["embed", "shorts", "live"].includes(part));
      const id = marker >= 0 ? parts[marker + 1] : "";
      return YOUTUBE_ID.test(id) ? id : null;
    }
  } catch {
    return null;
  }

  return null;
}
